document.addEventListener("DOMContentLoaded", function () {
  function setupModalEventListeners() {
    const closeModalIcon = document.querySelector(".icon-closed");
    const overlayModal = document.querySelector(".overlay-modal-preview");

    const checkoutButton = document.querySelector(".action_button.add_to_cart");

    const carCheckoutbutton = document.querySelector(
      '.sf-cart__submit-controls button[name="checkout"]'
    );

    closeModalIcon.addEventListener("click", (e) => {
      e.preventDefault();
      handleCloseModal();
    });

    overlayModal.addEventListener("click", (e) => {
      e.preventDefault();
      handleCloseModal();
    });

    checkoutButton.addEventListener("click", (e) => {
      handleCloseModal();
      if (carCheckoutbutton) {
        e.preventDefault();
        carCheckoutbutton.click();
      } else {
      }
    });
  }

  function handleCloseModal() {
    const modalItem = document.querySelector(".wrapper-modal-preview");
    modalItem.classList.toggle("is-open");
  }

  // 在需要的地方调用事件监听器设置函数
  setupModalEventListeners();
});

// function handleImagePreview(imageUrl) {
//   const modalImg = document.querySelector(
//     ".wrapper-modal-preview .preview-img-modal .so-featured-image"
//   );
//   modalImg.style.display = "none";
//   modalImg.src = 'https://cdn.shopify.com/s/files/1/0743/6481/3624/files/loading_bg_c1a656d3-b9fc-4e86-9bb7-fb4ebbf44c3e.gif?v=1704283003'

//   if (imageUrl && imageUrl.includes("cdn.medzt.com")) {
//     modalImg.src = imageUrl;
//   } else if (modalImg.dataset.key !== imageUrl) {
//     imageUrl += "?" + new Date().getTime();
//     modalImg.addEventListener("load", function () {
//       modalImg.dataset.key = imageUrl;
//     });
//     modalImg.addEventListener("error", function () {
//       modalImg.onerror = null;
//       setTimeout(function () {
//         modalImg.src = imageUrl;
//       }, 500);
//     });
//     modalImg.src = imageUrl;
//   } else {
//     modalImg.src = imageUrl;
//   }

//   const modalItem = document.querySelector(".wrapper-modal-preview");
//   modalItem.classList.toggle("is-open");
//   modalImg.style.display = "block";
// }

function handleImagePreview(imageUrl) {
  const modalImg = document.querySelector(".wrapper-modal-preview .preview-img-modal .so-featured-image");

  // 初始加载图标显示
  modalImg.style.display = "block";
  const loadingIconUrl = 'https://cdn.shopify.com/s/files/1/0571/4676/9444/files/loading_bg_c1a656d3-b9fc-4e86-9bb7-fb4ebbf44c3e.gif?v=1728372027';
  modalImg.src = loadingIconUrl;

  // 清除旧的事件监听器，避免重复添加
  modalImg.onload = null;
  modalImg.onerror = null;

  function loadImage(url) {
    modalImg.onload = function () {
      modalImg.dataset.key = url; // 成功加载，更新数据标识
    };

    modalImg.onerror = function () {
      modalImg.src = loadingIconUrl; // 显示加载图标
      setTimeout(function () {
        // 重置src触发重新加载
        modalImg.src = url + "?" + new Date().getTime(); // 重新尝试加载图片，并防止缓存问题
      }, 500);
    };

    // 设置图片源为目标URL，尝试加载图片
    modalImg.src = url;
  }

  loadImage(imageUrl); // 加载图片

  const modalItem = document.querySelector(".wrapper-modal-preview");
  modalItem.classList.toggle("is-open"); // 控制模态框的显示
}


// 通过类名选择所有需要添加点击事件的元素
// const imageLinks = document.querySelectorAll(".image-link");

// 给每个图片链接元素添加点击事件监听器
// imageLinks.forEach((imageLink) => {
//   imageLink.addEventListener("click", (event) => {
//     event.preventDefault();
//     const imageUrl = imageLink.getAttribute("data-src");
//     handleImagePreview(imageUrl);
//   });
// });

function handleImageClick(imageUrl) {
  event.preventDefault();
  handleImagePreview(imageUrl);
}
